import { toSydneyDatetimeLocal } from './sydneyDateTime'
/**
 * Map investigation checklist steps to Browse Data presets (gaming / payout tools).
 */
export function getStepBrowseConfig(step) {
  const cat = String(step?.category || '')
  const title = String(step?.title || '').toLowerCase()
  if (cat !== 'Gaming & Transaction Review') return null
  if (title.includes('payout')) {
    return { subTab: 'payouts', days: 90, label: 'Browse payouts (90d)' }
  }
  if (title.includes('session') || title.includes('gaming')) {
    return { subTab: 'sessions', days: 90, label: 'Browse sessions (90d)' }
  }
  return { subTab: 'sessions', days: 90, label: 'Browse gaming data' }
}

export function toDatetimeLocalValue(date) {
  const d = date instanceof Date ? date : new Date(date)
  const pad = (n) => String(n).padStart(2, '0')
  return toSydneyDatetimeLocal(d)
}

export function defaultFromDaysAgo(days = 90) {
  const d = new Date()
  d.setDate(d.getDate() - days)
  d.setSeconds(0, 0)
  return toDatetimeLocalValue(d)
}
